/********************************************************
* RACTIVE VALIDATE
*
* Form validation module to be used with ractive JS
*
********************************************************/


/**********************************************
 DEPENDENCIES
**********************************************/



/**********************************************
 VARIABLE DECLARATION
**********************************************/

var self = {};
var view;


/**********************************************
 HELPER FUNCTIONS
**********************************************/



/**********************************************
 PRIVATE FUNCTIONS
**********************************************/

var fieldValidate = function(field) {
	field.min = typeof field.min !== 'undefined' ? field.min : 0;
	field.max = typeof field.max !== 'undefined' ? field.max : 1000;
	field.required = typeof field.required !== 'undefined' ? field.required : false;
	field.min = (field.required && (field.min == 0)) ? 1 : field.min;
	
	field.value = view.get(field.input);
	var valid = false;
	//console.log('working on - ' + field.input);
	field.value = String(field.value);

	if (typeof field.rule !== 'undefined') valid = field.rule(field.value);
	else if ((field.value.length >= field.min) && (field.value.length <= field.max)) {
		switch(field.type) {
			case 'email':
				var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	    		valid = re.test(field.value);
				break;
			case 'text':
				valid = true;

				break;
			case 'num':
				var re = /[0-9]|\./;
				valid = re.test(field.value);
				//if (!valid) console.log(field.value + ' apparently isn not valid');
				break;
			case 'password':
				valid = true;

				break;
			case 'number':
				valid = !isNaN(parseInt(field.value));
				//if (!valid) console.log(field.value + ' apparently isn not valid');
				break;
			case 'phone':
				// Accepts (123) 123-4567,  123-123-4567,  123.123.4567,  1231234567
				var re = /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/;
				valid = re.test(field.value);
				break;
			case 'date':
				valid = true;
				break;
			case 'image':
				// just assuming a url string
				valid = true;
				break;
			case 'link':
				//valid = true;
				if (field.value.indexOf('http://') === -1 && field.value.indexOf('https://') === -1) {
					//console.log('no http or https');
				}
				else valid = true;
				break;
		}
	}

	//if (!valid) console.log(field.value + ' apparently isn not valid');

	return valid;
}



/**********************************************
 PUBLIC FUNCTIONS
**********************************************/

self.check = function(ractive_view, validate_rules) {
	// store ractive view
	view = ractive_view;
	
	// Set initial state of flag
    var form_valid = true;

	// loop through rules
	for (i=0; i<validate_rules.length; i++) {
    	var valid = fieldValidate( validate_rules[i] );

    	// set error flag to reflect field status
    	if (typeof(validate_rules[i].error) !== 'undefined') view.set(validate_rules[i].error, !valid);

    	// if field isn't valid then flag form as not valid
    	if (!valid) form_valid = false;
    }

    return form_valid;
}

/**********************************************
 MODULE EXPORT
**********************************************/
module.exports = self;